export default String.raw`
<div class="customer-submenu">
    <div class="customer-submenu__header">
        {{translations.PromotionsAndCoupons}}
    </div>
    <div class="change-container">
        <div class="change-container__type">
            <button class="change-type-js replace-template-js change-container__type text {% if page.QueryString contains 'tab=discounts' or page.QueryString contains 'tab=discount-details' %} active {% endif %}" data-template="partials/customer-profile/discounts/discounts-content.html" data-container=".promotions-content-js" data-url="{{ page.BaseHref }}{{config.DefinedPages.CustomerProfile.Url}}?tab=discounts">{{ translations.Promotions }}</button>
        </div>
        <div class="change-container__type">
            <button class="change-type-js replace-template-js change-container__type text {% if page.QueryString contains 'tab=coupons' or page.QueryString contains 'tab=coupon-details' %} active {% endif %}" data-template="partials/customer-profile/discounts/coupons-content.html" data-container=".promotions-content-js" data-url="{{ page.BaseHref }}{{config.DefinedPages.CustomerProfile.Url}}?tab=coupons">{{ translations.Coupons }}</button>
        </div>
        <div class="slider"></div>
    </div>
    <div class="promises-message-js promises-message"></div>
    <div class="promotions-content-js container-js">
        {% if page.QueryString contains 'tab=coupons' or page.QueryString contains 'tab=coupon-details' -%}
            {% include 'partials/customer-profile/discounts/coupons-content.html' -%}
        {% else -%}
            {% include 'partials/customer-profile/discounts/discounts-content.html' -%}
        {% endif -%}
    </div>
</div>
`